(ns portal.advertiser-management.view
  (:require [common.widgets.page :as page]
            [portal.advertiser-table.view :refer [advertiser-data-grid]]
            [uix.core :refer [defui $]]))

(defui advertiser-management-page []
  ($ page/page
     ($ page/page-header
        {:title "Advertiser management"})
     ($ page/content-padding
        {:sx #js {:overflow "hidden"}}
        ($ advertiser-data-grid))))
